import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import {
  STORE_USERNAME,
  STORE_PASSWORD,
  STORE_USER_PROFILE,
  UserDetail,
} from '../reducers/user';

import {
  STORE_ERROR_MESSAGE,
  STORE_ERROR_BAR
} from '../reducers/errors';

import axios, { AxiosResponse } from 'axios';
import { push } from 'react-router-redux';

export const saveUsername = (username: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_USERNAME, username } as AnyAction);
    return true;
  };
};

export const savePassword = (password: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_PASSWORD, password } as AnyAction);
    return true;
  };
};

export const adminPortal = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
  window.open(`${getState().environment.ADMIN_PORTAL_URL}`);
};

export const designerPortal = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
  window.open(`${getState().environment.DESIGNER_PORTAL_URL}`);
};

export const doAuthentication = async (
  dispatch: Dispatch<AppState>,
  getState: () => AppState
) => {
  const params = {
    userName: '',
    passWord: ''
  };
  params.userName = getState().user.username || '';
  params.passWord = getState().user.password || '';

  if (params.userName === '') {
    const errorBar = true;
    const errorMessage = 'Username should not be blank.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.passWord === '') {
    const errorBar = true;
    const errorMessage = 'Password should not be blank.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  await axios({
    method: 'post',
    url: `${getState().environment.API_URL}login`,
    data: params,
  }).then(function (response: AxiosResponse) {

    if ((response.data.ugroup === 'Lab') || (response.data.ugroup === 'Manufacturer') || (response.data.ugroup === 'EDDL')) {

      const userDetails: UserDetail = {
        s: response.data.s,
        ugroup: response.data.ugroup,
        uroles: response.data.uroles,
        userName: response.data.USERNAME,
        userGroup: response.data.ugroup,
        groupNo: response.data.GROUPNO,
        email: response.data.EMAIL,
        nickName: response.data.NICKNAME,
        userType: response.data.USERTYPE,
        mobileNumber: response.data.MOBILE,
        allUserGroup: response.data.ALLUSERGROUP,
        dmeRequired: response.data.DMEREQUIRED,
        responsibilies: response.data.globalvars.responsibilies,
        roleName: response.data.globalvars.rolename,
        labCode: response.data.globalvars.mcustomer
      };

      dispatch({ type: STORE_USER_PROFILE, userDetails } as AnyAction);

      const username = '';
      const password = '';
      dispatch({ type: STORE_USERNAME, username } as AnyAction);
      dispatch({ type: STORE_PASSWORD, password } as AnyAction);

      dispatch(push('/app'));
    } else {
      const errorBar = true;
      const errorMessage = 'You are not authorized to access this application';
      dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
      dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    }

    return;
  }).catch(error => {

    const username = '';
    const password = '';
    dispatch({ type: STORE_USERNAME, username } as AnyAction);
    dispatch({ type: STORE_PASSWORD, password } as AnyAction);

    const errorMessage = error.response ? error.response.data.message : 'No response from server, Please try again later';
    const errorBar = true;
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);

  });

  // try {
  //   const response = await axios.post(
  //     `${getState().environment.API_URL}login`,
  //     params
  //   );
  //   const userDetails = response.data;
  //   dispatch({ type: STORE_USER_PROFILE, userDetails } as AnyAction);
  //   dispatch(push('/app'));
  //   const successSubmitOpen = true;
  //   const successsubmitmsg = 'Logged in successfully';
  //   dispatch({ type: STORE_SUCCESS_SUBMIT_MSG, successsubmitmsg } as AnyAction);
  //   dispatch({ type: STORE_SUCCESS_SUBMIT, successSubmitOpen } as AnyAction);

  //   const username = '';
  //   const password = '';
  //   dispatch({ type: STORE_USERNAME, username } as AnyAction);
  //   dispatch({ type: STORE_PASSWORD, password } as AnyAction);
  //   return;
  // } catch (e) {
  //   // ==> console.error(e);
  //   const username = '';
  //   const password = '';
  //   dispatch({ type: STORE_USERNAME, username } as AnyAction);
  //   dispatch({ type: STORE_PASSWORD, password } as AnyAction);
  //   const errorBar = true;
  //   const errorMessage = e.message;
  //   dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
  //   dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);

  // }
};

// export const initiateLogin = async (
//   dispatch: Dispatch<AppState>,
//   getState: () => AppState
// ) => {
//   const url = document.location!!.href;
//   let loadUrl = url;
//   var cnt = 0;
//   var ind = 0;
//   while (cnt !== 3) {
//     ind = loadUrl.indexOf('/', ind) + 1;
//     cnt++;
//   }
//   loadUrl = loadUrl.substring(0, ind);

//   const callbackUrl = loadUrl;
//   let responseType: string | undefined = getState().environment.ENV_MODE;
//   responseType = responseType!!.split('-').join(' ');
//   const loginUrl =
//     `${getState().environment.ENV_MODE}` +
//     `?client_id=${getState().environment.ENV_MODE}` +
//     `&redirect_uri=${callbackUrl}callback` +
//     `&response_type=${responseType}` +
//     `&scope=app.esim_support`;

//   window.location.replace(loginUrl || '');
// };



// WEBPACK FOOTER //
// ./src/actions/userAction.ts